const VALUES = ["system", "dark", "light"];

export function normalizeAppearancePreference(value) {
  return VALUES.includes(value) ? value : "system";
}

export function chooseEffectiveAppearance({ preference, systemAppearance, allowed, defaultAppearance }) {
  const policy = Array.isArray(allowed) ? allowed.filter(value => value === "dark" || value === "light") : [];
  const fallback = policy.includes(defaultAppearance) ? defaultAppearance : policy[0] || "dark";
  if (!VALUES.includes(preference)) return fallback;
  const requested = preference === "system" ? (systemAppearance === "light" ? "light" : "dark") : preference;
  return policy.includes(requested) ? requested : fallback;
}

export async function persistAppearancePreference(preference, { apiUrl, getHeaders = async () => ({}) } = {}) {
  const normalized = normalizeAppearancePreference(preference);
  if (!apiUrl) return normalized;
  const response = await fetch(`${apiUrl}/preferences`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...(await getHeaders(`${apiUrl}/preferences`, "PUT")) },
    body: JSON.stringify({ appearance: normalized })
  });
  if (!response.ok) throw new Error(`Unable to save appearance preference (${response.status})`);
  return normalized;
}
